export const META_TAGS = {
  META_TITLE: process.env.REACT_APP_META_TITLE,
  META_DESCRIPTION: process.env.REACT_APP_META_DESCRIPTION,
  OPEN_GRAPH_TITLE: process.env.REACT_APP_OPEN_GRAPH_TITLE,
  OPEN_GRAPH_IMAGE: process.env.REACT_APP_OPEN_GRAPH_IMAGE,
  OPEN_GRAPH_DESCRIPTION: process.env.REACT_APP_OPEN_GRAPH_DESCRIPTION,
};
